import { Component } from '@angular/core';
import { NavController, NavParams, MenuController } from 'ionic-angular';
import { PlayPage } from '../play/play';
import { Storage } from '@ionic/storage';
import { ReadstoryPage } from '../readstory/readstory';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { UserdataModel } from '../../providers/userdata-model';

@Component({
  selector: 'page-endgame',
  templateUrl: 'endgame.html'
})
export class EndgamePage {
  mood:string;
  scorePartial:number;
  difficulty:number;
  language:number;
  win:boolean;

  constructor(public functions: Functions, public rubedoSideMenu: MenuController, public userdataModel:UserdataModel, public translate: TranslateService, public navCtrl: NavController, public navParams: NavParams, private storage: Storage) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(false, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(false);
      
    this.scorePartial=0;
    this.mood="superhappy";
  }
  
  goToPlay(){
    this.navCtrl.popTo(PlayPage); 
  }

  goToMainMenu(){
    this.navCtrl.popToRoot();
  }

  goToReadStory(){
    this.navCtrl.push(ReadstoryPage, {});
  }
  
  /* --------- LIFECYCLE --------- */
  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(true);
    this.scorePartial = this.navParams.get('scorePartial'); 
    this.win = this.navParams.get('win'); 
    if(this.win){
      this.mood="superhappy";
    }else{
      this.mood="supersad";
    }
    this.functions.getDifficulty();
    this.functions.getLanguage();

    if(this.win){
      this.functions.startBgMusic('game_youWin');
    }else{
      this.functions.startBgMusic('game_youLost');
    }
  }
  
  ionViewWillLeave(){
    if(this.win){
      this.functions.stopBgMusic('game_youWin');
    }else{
      this.functions.stopBgMusic('game_youLost');
    }
    this.functions.startBgMusic('app_BgMusic');
  }
  
  /* --------- END IFECYCLE --------- */

}



// WEBPACK FOOTER //
// ./src/pages/endgame/endgame.ts